export const ErpSystemsList = {
  fortnox: {
    name: 'FORTNOX',
    backendName: 'FORTNOX',
    isSupportedByInHouseAccountingIntegration: true,
  },
  bjornLunden: {
    name: 'Björn Lundén',
    backendName: 'BJORN_LUNDEN',
    isSupportedByInHouseAccountingIntegration: false,
  },
  peAccounting: {
    name: 'PE Accounting',
    backendName: 'PE_ACCOUNTING',
    isSupportedByInHouseAccountingIntegration: false,
  },
  visma: {
    name: 'Visma eEkonomi',
    backendName: 'VISMA_E_ECONOMY',
    isSupportedByInHouseAccountingIntegration: true,
  },
  wint: {
    name: 'Wint',
    backendName: 'WINT',
    isSupportedByInHouseAccountingIntegration: false,
  },
  bokio: {
    name: 'Bokio',
    backendName: 'BOKIO',
    isSupportedByInHouseAccountingIntegration: false,
  },
  speedledger: {
    name: 'Speedledger',
    backendName: 'SPEEDLEDGER',
    isSupportedByInHouseAccountingIntegration: false,
  },
  hogia: {
    name: 'Hogia',
    backendName: 'HOGIA',
    isSupportedByInHouseAccountingIntegration: false,
  },
  dooer: {
    name: 'Dooer',
    backendName: 'DOOER',
    isSupportedByInHouseAccountingIntegration: false,
  },
  other: {
    name: '-',
    backendName: 'OTHER',
    isSupportedByInHouseAccountingIntegration: false,
  },
};
